import TooltipButton from './TooltipButton';

export default TooltipButton;
